var map = {
	"./Instagram.webp": 988,
	"./LinkedIn.png": 229,
	"./aws.png": 582,
	"./background1.jpg": 818,
	"./btb.png": 545,
	"./codeforces.png": 128,
	"./dmms.png": 346,
	"./download.png": 706,
	"./duhacks.jpeg": 945,
	"./duhacksp.jpeg": 581,
	"./forage.png": 981,
	"./fortune.jpg": 12,
	"./gfg.png": 815,
	"./git.png": 159,
	"./github.png": 965,
	"./github2.png": 733,
	"./githubp.png": 225,
	"./greatlearning.png": 705,
	"./hackerank-logo.png": 91,
	"./jp.jpeg": 112,
	"./leetcode.png": 58,
	"./portfolioimage.png": 251,
	"./postman.png": 881,
	"./stock.jpg": 808,
	"./stopwatch.png": 573,
	"./timer.png": 934,
	"./toon.jpg": 509,
	"./twitter.svg": 887,
	"./udemy.png": 7,
	"./uw.jpg": 83
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 471;